<template>
  <div class="settings mtb15">
    <div class="container-fluid">
      <div class="row">
        <!-- 小屏幕下的导航按钮 -->
        <div class="d-lg-none col-12 mb-3" v-if="!isMobile">
          <button
            class="btn btn-primary w-100 d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#navOffcanvas"
          >
            {{ currentTabTitle }}
            <i class="icon ion-md-menu"></i>
          </button>
        </div>

        <!-- 侧边导航抽屉 -->
        <div
          class="offcanvas offcanvas-start"
          tabindex="-1"
          id="navOffcanvas"
          v-if="!isMobile"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title">Menu</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div class="offcanvas-body">
            <ul class="nav nav-pills flex-column">
              <li class="nav-item" v-for="item in tabs" :key="item.path">
                <button
                  class="nav-link w-100 text-start"
                  :class="{ active: currentTab === item.path }"
                  @click="handleTabClick(item.path)"
                >
                  {{ item.title }}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <!-- 大屏幕下的侧边导航 -->
        <div class="col-lg-3 d-none d-lg-block">
          <ul
            class="nav nav-tabs nav-pills settings-nav"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item" v-for="item in tabs" :key="item.path">
              <button
                class="nav-link"
                :class="{ active: currentTab === item.path }"
                @click="handleTabClick(item.path)"
              >
                {{ item.title }}
              </button>
            </li>
          </ul>
        </div>

        <!-- 内容区域 -->
        <div class="col-lg-9">
          <div class="tab-content" id="myTabContent">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobileDevice } from "@/utils/index";
const bootstrap = require("bootstrap");
export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      tabs: [
        {
          title: "PROFILE",
          path: "/user/profile",
        },
        {
          title: "WALLET",
          path: "/user/wallet",
        },
        {
          title: "DEPOSIT",
          path: "/user/deposit",
        },
        {
          title: "WITHDRAW",
          path: "/user/withdraw",
        },
        // {
        //   title: "DEPOSIT DETAIL",
        //   path: "/user/deposit-detail",
        // },
        // {
        //   title: "WITHDRAWAL DETAIL",
        //   path: "/user/withdrawal-detail",
        // },
        {
          title: "ACCOUNT RECORDS",
          path: "/user/account-records",
        },
        // {
        //   title: "TRADING RECORDS",
        //   path: "/user/trading-records",
        // },
        {
          title: "WALLET ADDRESS",
          path: "/user/wallet-address",
        },
        // {
        //   title: "SETTINGS",
        //   path: "/user/settings",
        // },
      ],
    };
  },
  computed: {
    currentTab() {
      return this.$route.path;
    },
    currentTabTitle() {
      const currentTab = this.tabs.find((tab) => tab.path === this.currentTab);
      return currentTab ? currentTab.title : "Menu";
    },
  },
  methods: {
    handleTabClick(path) {
      this.$router.push(path);
      // 在小屏幕下点击导航后关闭抽屉
      const offcanvas = document.getElementById("navOffcanvas");
      if (offcanvas) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    },
  },
};
</script>

<style scoped>
/* 确保抽屉在小屏幕下有合适的宽度 */
.offcanvas {
  width: 280px;
}

/* 导航按钮样式 */
.nav-link {
  text-align: left;
  padding: 0.8rem 1rem;
  border: none;
  background: none;
  width: 100%;
  transition: all 0.3s ease;
}

.nav-link:hover:not(.active) {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark .nav-link:hover:not(.active) {
  background-color: rgba(255, 255, 255, 0.05);
}

/* 抽屉内导航项样式 */
.offcanvas .nav-link {
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.dark .offcanvas {
  background-color: #1e2126;
  color: #fff;
}

.dark .offcanvas .nav-link {
  color: #fff;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

/* 保持现有的导航样式 */
.settings-nav {
  background: #fff;
  border-radius: 2px;
  padding: 15px;
}

.dark .settings-nav {
  background: #1e2126;
}
</style>
